<template>
  <div class="std-splitpane" :class="[`std-splitpane--${horizontal ? 'horizontal' : 'vertical'}`]">
    <slot></slot>
  </div>
</template>
<script>
  import Pane from './pane.vue';

  export default {
    name: 'StdSplitpane',
    components: { Pane },
    props: {
      horizontal: {
        type: Boolean
      }
    }
  };
</script>
<style lang="less">
  .std-splitpane {
    display: flex;
    width: 100%;
    height: 100%;

    &--horizontal {
      flex-direction: column;
    }

    &--vertical {
      flex-direction: row;

      .splitpane__pane:first-child {
        flex: 1;
        margin-right: 60px;
      }
    }
  }
</style>
